import styled from "styled-components";
import { ProfileCashierButtonDefaultBox } from "./profile-cashier-button.default.box";

export const ProfileCashierButtonMrGreenBox = styled(ProfileCashierButtonDefaultBox)`
    background-color: ${({theme}) => theme.colors.brandSecondary};
    border: none;
`;
